import { render, staticRenderFns } from "./dashboard-speed.vue?vue&type=template&id=06f0827d"
import script from "./dashboard-speed.vue?vue&type=script&lang=js"
export * from "./dashboard-speed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports